import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Section1 from './section-1.vue';
  import Section2 from './section-2.vue';
  import Section3 from './section-3.vue';
  import Section4 from './section-4.vue';
  import Section5 from './section-5.vue';
  import { onMounted, reactive, ref, watch } from 'vue';
  import { request } from '@/utils';
  import { useRoute } from 'vue-router';
  import { IVariant, IProduct, TPurchaseKind, DEFAULT_PRODUCT, DEFAULT_VARIANT } from '@/types/product';
  import _ from 'lodash';
  import { shoppingCartStore, authStore } from '@/stores';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();
  const purchaseKind = ref<TPurchaseKind>('once');
  const quatity = ref(1);
  const variant = reactive<IVariant>(_.cloneDeep(DEFAULT_VARIANT));
  const product = reactive<IProduct>(_.cloneDeep(DEFAULT_PRODUCT));

  async function fetchVariant() {
    const { data } = await request.get<IVariant>(`/bean/variants/${route.params.id}`);
    Object.assign(variant, data);
    Object.assign(product, data.product);
  }

  function handleSelectVariant(variantId: number) {
    Object.assign(variant, product.variants.find(item => item.id === variantId));
  }

  watch(
    () => variant.id,
    () => {
      quatity.value = 1;
      purchaseKind.value = variant.price_type === 'subscribe' ? 'delivery_weekly' : 'once';
    }
  );

  onMounted(() => {
    fetchVariant();
    if (authStore.isLogin) {
      shoppingCartStore.fetchData();
    }
  });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Section1, {
      "purchase-kind": purchaseKind.value,
      "onUpdate:purchase-kind": _cache[0] || (_cache[0] = ($event: any) => ((purchaseKind).value = $event)),
      quatity: quatity.value,
      "onUpdate:quatity": _cache[1] || (_cache[1] = ($event: any) => ((quatity).value = $event)),
      variant: _unref(variant),
      product: _unref(product),
      onSelectVariant: handleSelectVariant
    }, null, 8, ["purchase-kind", "quatity", "variant", "product"]),
    _createVNode(Section2, { product: _unref(product) }, null, 8, ["product"]),
    _createVNode(Section3, { product: _unref(product) }, null, 8, ["product"]),
    _createVNode(Section4),
    (_unref(product).id)
      ? (_openBlock(), _createBlock(Section5, {
          key: 0,
          product: _unref(product)
        }, null, 8, ["product"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})